import { Connector } from '../../common/redux/api/web-api'

export function getConnectorState(connector: Connector | null, isOcpp?: boolean): ConnectorState {
    if (connector && isOcpp) {
        switch (connector.ocppStatus) {
            case 'Available':
                return ConnectorState.AVAILABLE
            case 'Preparing':
                return ConnectorState.PREPARING
            case 'Charging':
                return ConnectorState.CHARGING
            case 'SuspendedEVSE':
                return ConnectorState.PAUSED_BY_CHARGER
            case 'SuspendedEV':
                return ConnectorState.PAUSED_BY_VEHICLE
            case 'Finishing':
                return ConnectorState.FINISHING
            case 'Reserved':
                return ConnectorState.RESERVED
            case 'Unavailable':
                return ConnectorState.UNAVAILABLE
            case 'Faulted':
                return ConnectorState.FAULTED
            default:
                return ConnectorState.ERROR
        }
    }

    if (connector?.isCharging) return ConnectorState.CHARGING
    if (connector?.offByUser) return ConnectorState.UNAVAILABLE
    if (connector?.evConnectorState === null) return ConnectorState.AVAILABLE

    switch (connector?.evConnectorState) {
        case 'A1NotConnected':
        case 'A2NotConnected':
            return ConnectorState.AVAILABLE
        case 'B1Connected':
        case 'B2Connected':
        case 'C2WaitLock':
        case 'C1ConnectedRequestingCharge':
            return ConnectorState.CONNECTED
        case 'C1WaitStop':
        case 'C2ConnectedCharging':
            return ConnectorState.CHARGING
        default:
            return ConnectorState.ERROR
    }
}

export const remoteStartIsAvailable = (connector: Connector | null): boolean => {
    const connectorState = getConnectorState(connector, true)
    return connectorState === ConnectorState.PREPARING || connectorState === ConnectorState.FINISHING
}

export const remoteStopIsAvailable = (connector: Connector | null): boolean => {
    const connectorState = getConnectorState(connector, true)
    return (
        connectorState === ConnectorState.CHARGING ||
        connectorState === ConnectorState.PAUSED_BY_CHARGER ||
        connectorState === ConnectorState.PAUSED_BY_VEHICLE
    )
}

export enum ConnectorMode {
    ON = 'On',
    OFF = 'Off',
}

export interface ConnectorInterface {
    isCharging: boolean | undefined
    onByUserOrSchedule: boolean | undefined
    offByUser: boolean | undefined
    connectorFunctionType: string | undefined
    mode: ConnectorMode
    evConnectorState:
        | null
        | undefined
        | 'A1NotConnected'
        | 'A2NotConnected'
        | 'B1Connected'
        | 'B2Connected'
        | 'C2WaitLock'
        | 'C1ConnectedRequestingCharge'
        | 'C1WaitStop'
        | 'C2ConnectedCharging'

    ocppStatus?:
        | undefined
        | null
        | 'Available'
        | 'Preparing'
        | 'Charging'
        | 'SuspendedEVSE'
        | 'SuspendedEV'
        | 'Finishing'
        | 'Reserved'
        | 'Unavailable'
        | 'Faulted'
}

export enum ConnectorState {
    'AVAILABLE', // both
    'PREPARING', // ocpp
    'CONNECTED', // non-ocpp
    'CHARGING', // both
    'PAUSED_BY_CHARGER', // ocpp
    'PAUSED_BY_VEHICLE', // ocpp
    'FINISHING', // ocpp
    'RESERVED', // ocpp
    'UNAVAILABLE', // ocpp
    'FAULTED', // ocpp
    'OFF', // non-ocpp
    'ERROR', // both
}
